import React from 'react';
import { observer } from 'mobx-react';
import FeedEntryIndex from 'components/feed/feed_entry_index';
import { AppUI } from '@seedlang/state';
import Link from 'components/link';
import styled from '@emotion/styled';
import DesktopTitle from 'components/desktop_title';
import DesktopOnly from 'utils/desktop_only';

const Wrapper = styled.div`
  display: flex;
`;

const Left = styled.div`
  width: 300px;
  margin-right: 10px;
`;

const Right = styled.div`
  flex: 1;
`;

const Row = styled.div`
  cursor: pointer;
  height: 68px;
  display: flex;
  background: #FFF;
  position: relative;
  margin: 0;
  border-bottom: 1px solid #e8e8e8;
  font-size: 14px;
  padding: 0 10px;
  display: flex;
  align-items: center;
  font-weight: bold;
  justify-content: center;
`;

@observer
class Feed extends React.Component {
  get routeName() {
    return AppUI.routeStore.routeName;
  }

  render() {
    return (
      <Wrapper>
        <Left>
          <DesktopOnly>
            <DesktopTitle>
              Feed Filters
            </DesktopTitle>
          </DesktopOnly>
          <Link to='feeds.index'>
            <Row
              selected={this.routeName === 'feeds.index'}
            >
              All Feed Entries
            </Row>
          </Link>
          <Link to='my.feed'>
            <Row
              selected={this.routeName === 'my.feed'}
            >
              My Feed Entries
            </Row>
          </Link>
        </Left>
        <Right>
          <DesktopOnly>
            <DesktopTitle>
              Feed Entries
            </DesktopTitle>
          </DesktopOnly>
          <FeedEntryIndex
            show={this.routeName}
            user={this.routeName === 'my.feed' ? AppUI.user : null}
          />
        </Right>
      </Wrapper>
    );
  }
}

export default Feed;
